import paramHistory from './paramHistory.reducer';

export default paramHistory;


// WEBPACK FOOTER //
// src/main/components/paramHistory/store/reducers/index.js